// Generated by BUCKLESCRIPT VERSION 5.0.3, PLEASE EDIT WITH CARE
'use strict';

var List = require("bs-platform/lib/js/list.js");
var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var Pervasives = require("bs-platform/lib/js/pervasives.js");
var Caml_format = require("bs-platform/lib/js/caml_format.js");

var $$default = /* record */[
  /* action : Pending */4,
  /* left */"",
  /* right */"",
  /* total */0
];

function make(param) {
  return $$default;
}

function toInfix(action) {
  var exit = 0;
  if (typeof action === "number") {
    switch (action) {
      case 0 : 
          return (function (prim, prim$1) {
              return prim + prim$1;
            });
      case 2 : 
          return (function (prim, prim$1) {
              return prim / prim$1;
            });
      case 5 : 
          return (function (prim, prim$1) {
              return prim * prim$1;
            });
      case 6 : 
          return (function (prim, prim$1) {
              return prim - prim$1;
            });
      case 1 : 
      case 3 : 
      case 4 : 
      case 7 : 
      case 8 : 
          exit = 1;
          break;
      
    }
  } else {
    exit = 1;
  }
  if (exit === 1) {
    return (function (left, param) {
        return left;
      });
  }
  
}

function strEmpty(str) {
  return str.length === 0;
}

function isFloat(str) {
  return str.includes(".");
}

function toFloat(str) {
  var match = str.length === 0;
  if (match) {
    return 0;
  } else {
    return Caml_format.caml_float_of_string(str);
  }
}

function toString(flt) {
  var str = flt.toString();
  var match = str.endsWith(".");
  if (match) {
    return str.replace(".", "");
  } else {
    return str;
  }
}

function find(lst, predicate) {
  if (lst) {
    return List.find(predicate, lst);
  } else {
    return $$default;
  }
}

function multiply(factor, num) {
  return toString(factor * toFloat(num));
}

function execute(infix, left, right) {
  return Curry._2(infix, toFloat(left), toFloat(right));
}

function update(input, param) {
  var right = param[/* right */2];
  var left = param[/* left */1];
  var action = param[/* action */0];
  var match;
  if (input === ".") {
    var exit = 0;
    if (typeof action === "number" && action === 4) {
      var match$1 = left.includes(".");
      match = /* tuple */[
        match$1 ? left : left + input,
        right
      ];
    } else {
      exit = 1;
    }
    if (exit === 1) {
      var match$2 = right.includes(".");
      match = /* tuple */[
        left,
        match$2 ? right : right + input
      ];
    }
    
  } else {
    match = typeof action === "number" ? (
        action !== 3 ? (
            action !== 4 ? /* tuple */[
                left,
                right + input
              ] : /* tuple */[
                left + input,
                right
              ]
          ) : /* tuple */[
            left,
            right
          ]
      ) : /* tuple */[
        left,
        right + input
      ];
  }
  var right$prime = match[1];
  var left$prime = match[0];
  return /* record */[
          /* action */action,
          /* left */left$prime,
          /* right */right$prime,
          /* total */execute(toInfix(action), left$prime, right$prime)
        ];
}

function createEquals(param) {
  var total = param[/* total */3];
  var sTotal = toString(total);
  return /* record */[
          /* action : Equals */3,
          /* left */sTotal,
          /* right */sTotal,
          /* total */total
        ];
}

function addEquals(lst, cur) {
  var match = find(lst, (function (param) {
          return param[/* action */0] !== /* Equals */3;
        }));
  var prev = update("", /* record */[
        /* action */match[/* action */0],
        /* left */toString(cur[/* total */3]),
        /* right */match[/* right */2],
        /* total */0
      ]);
  var match$1 = cur[/* action */0];
  if (typeof match$1 === "number" && match$1 === 3) {
    return /* :: */[
            createEquals(prev),
            /* :: */[
              prev,
              /* [] */0
            ]
          ];
  } else {
    return /* :: */[
            createEquals(cur),
            /* [] */0
          ];
  }
}

function doOperation(factor, param) {
  var right = param[/* right */2];
  var left = param[/* left */1];
  var action = param[/* action */0];
  var match = right === "" ? (
      typeof action === "number" && action === 4 ? /* tuple */[
          multiply(factor, left),
          right
        ] : /* tuple */[
          left,
          multiply(factor, left)
        ]
    ) : (
      typeof action === "number" && action === 3 ? /* tuple */[
          multiply(factor, left),
          multiply(factor, right)
        ] : /* tuple */[
          left,
          multiply(factor, right)
        ]
    );
  return update("", /* record */[
              /* action */action,
              /* left */match[0],
              /* right */match[1],
              /* total */0
            ]);
}

var Operation = /* module */[
  /* default */$$default,
  /* make */make,
  /* toInfix */toInfix,
  /* strEmpty */strEmpty,
  /* isFloat */isFloat,
  /* toFloat */toFloat,
  /* toString */toString,
  /* find */find,
  /* multiply */multiply,
  /* execute */execute,
  /* update */update,
  /* createEquals */createEquals,
  /* addEquals */addEquals,
  /* doOperation */doOperation
];

var context = React.createContext(/* tuple */[
      /* [] */0,
      (function (param) {
          return /* () */0;
        })
    ]);

var make$1 = context.Provider;

var Provider = /* module */[/* make */make$1];

function reducer(state, action) {
  var match = state ? /* tuple */[
      state[0],
      state[1]
    ] : /* tuple */[
      $$default,
      state
    ];
  var old = match[1];
  var current = match[0];
  var total = current[/* total */3];
  var exit = 0;
  if (typeof action === "number") {
    switch (action) {
      case 1 : 
          return /* [] */0;
      case 3 : 
          return Pervasives.$at(addEquals(state, current), state);
      case 4 : 
          return state;
      case 0 : 
      case 2 : 
      case 5 : 
      case 6 : 
          exit = 1;
          break;
      case 7 : 
      case 8 : 
          exit = 2;
          break;
      
    }
  } else {
    var input = action[0];
    var match$1 = current[/* action */0];
    var exit$1 = 0;
    if (typeof match$1 === "number" && match$1 === 3) {
      return Pervasives.$at(/* :: */[
                  update(input, $$default),
                  /* [] */0
                ], state);
    } else {
      exit$1 = 3;
    }
    if (exit$1 === 3) {
      return Pervasives.$at(/* :: */[
                  update(input, current),
                  /* [] */0
                ], old);
    }
    
  }
  switch (exit) {
    case 1 : 
        var match$2 = current[/* action */0];
        return /* :: */[
                /* record */[
                  /* action */action,
                  /* left */toString(total),
                  /* right */"",
                  /* total */total
                ],
                typeof match$2 === "number" && match$2 === 3 ? state : old
              ];
    case 2 : 
        var match$3 = current[/* action */0];
        var exit$2 = 0;
        if (typeof match$3 === "number" && !(match$3 !== 4 || total !== 0)) {
          return state;
        } else {
          exit$2 = 3;
        }
        if (exit$2 === 3) {
          if (typeof action === "number") {
            if (action !== 7) {
              if (action >= 8) {
                return Pervasives.$at(/* :: */[
                            doOperation(0.01, current),
                            /* [] */0
                          ], old);
              } else {
                return state;
              }
            } else {
              return Pervasives.$at(/* :: */[
                          doOperation(-1, current),
                          /* [] */0
                        ], old);
            }
          } else {
            return state;
          }
        }
        break;
    
  }
}

function useDisplay(param) {
  var match = React.useContext(context);
  var operations = match[0];
  if (operations) {
    var match$1 = List.hd(operations);
    var right = match$1[/* right */2];
    var match$2 = right.length === 0;
    if (match$2) {
      return match$1[/* left */1];
    } else {
      return right;
    }
  } else {
    return "0";
  }
}

function useAddOperation(param) {
  var match = React.useContext(context);
  var dispatch = match[1];
  return Curry.__1(dispatch);
}

exports.Operation = Operation;
exports.context = context;
exports.Provider = Provider;
exports.reducer = reducer;
exports.useDisplay = useDisplay;
exports.useAddOperation = useAddOperation;
/* context Not a pure module */
